module.exports = __webpack_public_path__ + "img/移动-1.30da3971.png";